
<template>
    <div class="Background">
        <div class="link_location">
            <h2 class="Title">
                {{ $store.getters.t('통계') }}  
                <v-icon class="mdi mdi-chevron-right" /><span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('VOD 통계') }}</span>
                </h2>
        </div>
        <VodStatistics />
    </div>
</template>

<script>
import  VodStatistics from '@/components/statistics/vodstatistics/VodStatistics.vue';

export default {
    components: {
        VodStatistics,
    },
    data() {
        return {
            
        };
    }
}
</script>

<style lang="scss" scoped>

</style>
